export default __webpack_public_path__ + "static/media/img-0503-holy-see-half-face.475d7440.png";